export default {
    url: 'vanlife',
    include: ['jp'],
};
